import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const globalAny = window as unknown as { __msalInstance?: PublicClientApplication };
const msalInstance = globalAny.__msalInstance ?? new PublicClientApplication(msalConfig);
globalAny.__msalInstance = msalInstance;
export default msalInstance;
